import React from 'react';
import OpenOrderItemDetail from '../../../../../components/link/OpenOrderItemDetail';
import OpenPreviewProductDetail from '../../../../../containers/app/common/OpenPreviewProductDetail';
import { DATE_FORMAT } from '../../../../../constants/service/common/utilConstants';
import { ORDER_ITEM_STATUS_TEXT } from '../../../../../constants/service/app/orderConstants';
import { setDash, setNumberWithComma } from '../../../../../lib/common';
import { setDateFormat } from '../../../../../lib/moment';

const columns = () => {
  return [
    {
      title: '주문번호',
      dataIndex: 'orderId',
      render: (value, record) => ({
        children: value,
        props: {
          rowSpan: record.rowSpan,
        },
      }),
    },
    {
      title: '상품 주문번호',
      dataIndex: 'orderItemId',
      render: (value) => <OpenOrderItemDetail text={value} orderItemId={value} />,
    },
    {
      title: '주문 상태',
      dataIndex: 'orderItemStatus',
      render: (value) => ORDER_ITEM_STATUS_TEXT[value],
    },
    {
      title: '상품명',
      dataIndex: 'productName',
      render: (value, record) => <OpenPreviewProductDetail text={value} productId={record.productId} />,
    },
    {
      title: '옵션정보',
      dataIndex: 'productOption',
      render: (value) => setDash(value),
    },
    {
      title: '수량',
      dataIndex: 'quantity',
      render: (value) => setNumberWithComma(value),
    },
    {
      title: '상품 별 총 주문금액',
      dataIndex: 'totalPrice',
      render: (value) => setNumberWithComma(value),
    },
    {
      title: '배송 완료 일시',
      dataIndex: 'completeDate',
      render: (value) => setDateFormat(value, DATE_FORMAT.YMD_HM_DOT_FORMAT),
    },
  ];
};

export default columns;
